var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSignAt = function SvgSignAt(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sign-at 1",
    clipPath: "url(#clip0_1854_5046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign-at--mail-email-at-sign-read-address"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4855 7.99977C11.4938 8.4552 11.4113 8.90773 11.2427 9.33092C11.0742 9.75411 10.823 10.1395 10.5039 10.4645C10.1847 10.7895 9.80402 11.0477 9.38398 11.2239C8.96394 11.4002 8.51299 11.4909 8.05748 11.4909C7.60196 11.4909 7.15102 11.4002 6.73098 11.2239C6.31094 11.0477 5.93022 10.7895 5.61108 10.4645C5.29194 10.1395 5.04076 9.75411 4.87222 9.33092C4.70368 8.90773 4.62116 8.4552 4.62948 7.99977C4.64588 7.10144 5.01425 6.24545 5.65534 5.61596C6.29643 4.98647 7.159 4.63379 8.05748 4.63379C8.95595 4.63379 9.81852 4.98647 10.4596 5.61596C11.1007 6.24545 11.4691 7.10144 11.4855 7.99977Z",
    stroke: "#262626",
    fill: "none",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4851 7.99986V9.48558C11.4851 13.4741 17.7365 9.71415 14.4565 4.297C13.7961 3.16906 12.8534 2.23242 11.7213 1.57918C10.5891 0.925938 9.30645 0.578591 7.99938 0.571289C6.90128 0.57468 5.8176 0.821477 4.82632 1.29391C3.83504 1.76635 2.96083 2.45268 2.26662 3.30349C1.5724 4.15431 1.07544 5.14845 0.81151 6.21436C0.547581 7.28028 0.523246 8.39144 0.740257 9.46789C0.957268 10.5443 1.41023 11.5593 2.06653 12.4397C2.72284 13.3201 3.56616 14.044 4.5358 14.5594C5.50545 15.0748 6.57729 15.3688 7.67419 15.4202C8.77108 15.4717 9.86574 15.2793 10.8794 14.857",
    stroke: "#262626",
    strokeWidth: 1.14286,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1854_5046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSignAt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sign-at.39eb47e3418340912cfb8164ed7c78ef.svg";